import { createTheme } from "@mui/material/styles";

// Global MUI typography font-family. The stack always ends in a generic
// keyword so a missing webfont (slow/blocked CDN) can never fall back to a
// browser-default serif (Times New Roman).
const appFontFamily = [
  "Montserrat",
  "-apple-system",
  "BlinkMacSystemFont",
  "Segoe UI",
  "Roboto",
  "Oxygen",
  "Ubuntu",
  "Cantarell",
  "Fira Sans",
  "Droid Sans",
  "Helvetica Neue",
  "sans-serif",
].join(", ");

export const theme = createTheme({
  typography: {
    fontFamily: appFontFamily,
  },
});